import {gql} from '@apollo/client'

export default gql`
  query GetUser($userId: ID!) {
    user(id: $userId) {
      user_name
      role
      survey_language
      trial_type
      section_1_completed_date
      surveys {
        id
        title
        survey_type
        completed_date
        section_2_completed_date
        section_3_completed_date
      }
    }
  }
`